export default __webpack_public_path__ + "static/media/blog-4.5e18445e.jpg";